import React from "react";
import { useState } from "react";
import { Row, Col, Card, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import Loader from "../../common/Loader";
import NoData from "../../common/NoData";
import { Translate } from "../../Enums/Tranlate";
import CardItem from "./CardItem";
import UsersService from "../../../services/UsersService";
import AddUserModal from "./AddUserModal";
import Pagination from "../../common/Pagination/Pagination";

const Users = () => {
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [tab, setTab] = useState("active");
	const [addModal, setAddModal] = useState(false);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const lang = useSelector((state) => state.auth?.lang);
	const usersService = new UsersService();
	const Auth = useSelector((state) => state.auth?.auth);
	const isExist = (data) => Auth?.roles?.includes(data);
	const search = useSelector((state) => state.auth.search);

	return (
		<div className="department">
			<div className="mb-4">
				<div className="search-card d-flex justify-content-between align-items-center">
					<div>
						<span
							style={{
								fontWeight: "600",
								textTransform: "capitalize",
								color: "#000",
							}}>
							{Translate[lang].users}
						</span>
					</div>
					<div>
						{/* {isExist("add_users") && (
							<Button
								variant="primary"
								className="me-2 h-75"
								onClick={() => {
									setAddModal(true);
								}}>
								<i
									className={`la la-plus ${
										lang === "en" ? "mr-2" : "ml-2"
									}`}></i>
								{Translate[lang]?.add} {Translate[lang]?.user}
							</Button>
						)} */}
					</div>
				</div>
			</div>
			<div className="mb-4">
				<div className="tabs-div">
					{["active", "deactive"]?.map((res) => {
						return (
							<p
								onClick={() => {
									setTab(res);
									setShouldUpdate((prev) => !prev);
								}}
								className={res === tab ? "activeP" : ""}>
								{Translate[lang][res]}
							</p>
						);
					})}
				</div>
			</div>

			<Row>
				<Col lg={12}>
					<Card>
						<div
							className={`${hasData === 0 ? "text-center" : "table-style"} `}>
							{loading && (
								<div style={{ height: "400px" }}>
									<Loader />
								</div>
							)}

							{hasData === 1 && !loading && (
								<Table responsive>
									<thead>
										<tr className="text-center">
											<th>
												<strong>{Translate[lang]?.name}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.phone}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.email}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.status}</strong>
											</th>
											<th>
												<strong>{Translate[lang]?.action}</strong>
											</th>
										</tr>
									</thead>

									<tbody className="table-body">
										{data?.map((item, index) => {
											return (
												<CardItem
													index={index}
													setShouldUpdate={setShouldUpdate}
													key={index}
													item={item}
												/>
											);
										})}
									</tbody>
								</Table>
							)}
							{hasData === 0 && <NoData />}
							<Pagination
								setData={setData}
								service={usersService}
								shouldUpdate={shouldUpdate}
								setHasData={setHasData}
								setLoading={setLoading}
								search={search}
								isDeleted={tab === "active" ? false : true}
							/>
						</div>
					</Card>
				</Col>
			</Row>
			{addModal && (
				<AddUserModal
					addModal={addModal}
					setShouldUpdate={setShouldUpdate}
					setAddModal={() => setAddModal(false)}
				/>
			)}
		</div>
	);
};

export default Users;
